<template>
    <MainTempComp
        ref="mainTempRef"
        :searchOption="data.searchOption"
        :handleSearch="handleSearch"
        :showPage="false"
        :showSearch="isAdmin"
    >
        <template #header>
            <span v-if="isAdmin">
                <span class="fm-header__gap"></span>
                <el-button type="primary" @click="handleSearch" :loading="loading">
                    <i class="el-icon-refresh"></i> 查询
                </el-button>
                <el-button type="default" @click="resetSearch">重置</el-button>
            </span>
            <span v-else class="userSite">
                <h2>{{ userSite }}</h2>
            </span>
        </template>

        <template #main>
            <!-- 加载状态 -->
            <el-skeleton v-if="loading" animated :rows="8" style="margin-bottom: 20px;"></el-skeleton>

            <div class="fm-collapse" v-else>
                <el-collapse v-model="activeNames" @change="handleCollapseChange">
                    <!-- 全部数据 -->
                    <el-collapse-item title="全部数据" name="1">
                        <div class="fm-board">
                            <div class="fm-card  fm-card--online">
                                <div class="fm-card__body" @click.self="router().push({ path: '/hardwareSettings/statusIndex' })">
                                    <div class="fm-card__icon">
                                        <el-icon size="50"><Monitor /></el-icon>
                                    </div>
                                    <div class="fm-card__text">
                                        <div class="fm-card__count">
                                            {{ statisticsAllData?.yj?.zxCount || 0 }}/{{ statisticsAllData?.yj?.allCount || 0 }}
                                        </div>
                                        <div class="fm-card__desc">在线设备/总设备</div>
                                    </div>
                                </div>
                            </div>

                            <div class="fm-card  fm-card--vip">
                                <div class="fm-card__body" @click.self="router().push({ path: '/userManage' })">
                                    <div class="fm-card__icon">
                                        <el-icon size="50"><User /></el-icon>
                                    </div>
                                    <div class="fm-card__text">
                                        <div class="fm-card__count">{{ statisticsAllData?.hy || 0 }}</div>
                                        <div class="fm-card__desc">会员数</div>
                                    </div>
                                </div>
                            </div>

                            <div class="fm-card  fm-card--balance">
                                <div class="fm-card__body" @click.self="router().push({ path: '/userDeposit' })">
                                    <div class="fm-card__icon">
                                        <el-icon size="50"><Money /></el-icon>
                                    </div>
                                    <div class="fm-card__text">
                                        <div class="fm-card__count">{{ formatMoney(statisticsAllData?.hyye || 0) }}</div>
                                        <div class="fm-card__desc">会员余额（元）</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>

                    <!-- 今日数据 -->
                    <el-collapse-item title="今日数据" name="2">
                        <div class="fm-board">
                            <div class="fm-card  fm-card--today-use">
                                <div class="fm-card__body">
                                    <div class="fm-card__icon">
                                        <el-icon size="50"><PieChart /></el-icon>
                                    </div>
                                    <div class="fm-card__text">
                                        <div class="fm-card__count">
                                            {{ apiStatisticsDayCountData?.sycs || 0 }}
                                        </div>
                                        <div class="fm-card__desc">今日使用次数</div>
                                    </div>
                                </div>
                            </div>

                            <div class="fm-card  fm-card--today-earn">
                                <div class="fm-card__body">
                                    <div class="fm-card__icon">
                                        <el-icon size="50"><Coin /></el-icon>
                                    </div>
                                    <div class="fm-card__text">
                                        <div class="fm-card__count">{{ formatMoney(statisticsAllData?.syje || 0) }}</div>
                                        <div class="fm-card__desc">今日收益（元）</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>

                    <!-- 收益趋势：增加key确保重新渲染，添加v-if确保DOM存在 -->
                    <el-collapse-item title="收益趋势" name="3" key="profit-chart">
                        <!-- 强制渲染内容（即使折叠），通过样式控制显示 -->
                        <div class="chart-wrapper" :class="{ 'chart-hidden': !activeNames.includes('3') }">
                            <div id="main" class="fm-chart"></div>
                        </div>
                    </el-collapse-item>

                    <!-- 收益趋势表：独立日期 + 独立数据 -->
                    <el-collapse-item title="收益趋势表" name="4" key="profit-table-1">
                        <div class="search-bar" style="margin-bottom: 15px; padding: 10px; background: #f8f9fa; border-radius: 8px;">
                            <el-date-picker
                                v-model="dateRange1"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="YYYY-MM-DD"
                                value-format="YYYY-MM-DD"
                                style="width: 300px; margin-right: 10px;"
                            ></el-date-picker>
                            <el-button type="primary" @click="getProfitTrend1">查询</el-button>
                            <el-button @click="resetDateRange1">重置</el-button>
                        </div>

                        <el-table :data="tableData1" border style="width: 100%" v-loading="tableLoading1">
                            <el-table-column label="日期" prop="date" />
                            <el-table-column label="消费总额">
                                <template #default="scope">{{ formatMoney(scope.row.consumptionTotal || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="消费返还">
                                <template #default="scope">{{ formatMoney(scope.row.consumptionReturn || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="充值总额">
                                <template #default="scope">{{ formatMoney(scope.row.rechargeAmount || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="充值返还">
                                <template #default="scope">{{ formatMoney(scope.row.rechargeRefund || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="充值退款">
                                <template #default="scope">{{ formatMoney(scope.row.rechargeReturn || 0) }}</template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>

                    <!-- 实际收益表：完全独立 -->
                    <el-collapse-item title="实际收益表" name="5" key="profit-table-2">
                        <div class="search-bar" style="margin-bottom: 15px; padding: 10px; background: #f8f9fa; border-radius: 8px;">
                            <el-date-picker
                                v-model="dateRange2"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="YYYY-MM-DD"
                                value-format="YYYY-MM-DD"
                                style="width: 300px; margin-right: 10px;"
                            ></el-date-picker>
                            <el-button type="primary" @click="getProfitTrend2">查询</el-button>
                            <el-button @click="resetDateRange2">重置</el-button>
                        </div>

                        <el-table :data="tableData2" border style="width: 100%" v-loading="tableLoading2">
                            <el-table-column label="日期" prop="date" />
                            <el-table-column label="实际消费金额">
                                <template #default="scope">{{ formatMoney(scope.row.actualConsumption || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="赠送消费金额">
                                <template #default="scope">{{ formatMoney(scope.row.giftConsumption || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="实际充值金额">
                                <template #default="scope">{{ formatMoney(scope.row.actualRecharge || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="充值赠送金额">
                                <template #default="scope">{{ formatMoney(scope.row.actualGiftRecharge || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="时长消费金额">
                                <template #default="scope">{{ formatMoney(scope.row.packageDurationAmount || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="总消费金额">
                                <template #default="scope">{{ formatMoney(scope.row.totalConsumption || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="总充值金额">
                                <template #default="scope">{{ formatMoney(scope.row.totalRecharge || 0) }}</template>
                            </el-table-column>
                            <el-table-column label="总退款金额">
                                <template #default="scope">{{ formatMoney(scope.row.totalRefund || 0) }}</template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </template>
    </MainTempComp>

    <look-detailed ref="detailedRef" :title="data.detailedTitle" />
</template>

<script>
import {
    inject,
    onMounted,
    provide,
    reactive,
    ref,
    onBeforeUnmount,
    nextTick,
} from "vue";
import LookDetailed from "./children/look-detailed.vue";
import ExpenditureTable from "./children/expenditure-table.vue";
import {
    apiUserParkingLot,
    apiUserParkingLotList
} from "@/api/requestApis.js";
import {
    apiStatisticsAll, apiStatisticsMonthCount, apiStatisticsDayCount, apiStatisticsAll2,
    apiCalculateActualConsumptionAndRecharge
} from "@/api/statistics";
import router from "@/router";
import {ElMessage, ElIcon} from "element-plus";
import {Coin, Money, Monitor, PieChart, User} from "@element-plus/icons-vue";

export default {
    name: "financeManage",
    methods: {
        router() {
            return router
        },
        // 格式化金额
        formatMoney(val) {
            return Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    components: {Money, PieChart, User, Coin, ElIcon, Monitor, LookDetailed, ExpenditureTable},
    setup() {
        // 核心修改：设置默认展开所有面板（1,2,3,4,5）
        const activeNames = ref(['1', '2', '3', '4', '5'])
        const mainTempRef = ref(null);
        const detailedRef = ref(null);
        const statisticsAllData = ref({}) ;
        const apiStatisticsDayCountData = ref({}) ;
        const apiStatisticsMonthCountData = ref({}) ;
        const loading = ref(false);

        // =============== 表格1：收益趋势表 ===============
        const tableLoading1 = ref(false);
        const tableData1 = ref([]);
        const dateRange1 = ref(getLast30DaysRange());

        // =============== 表格2：实际收益表 ===============
        const tableLoading2 = ref(false);
        const tableData2 = ref([]);
        // 实际收益表默认：当年1月1日 ~ 今天
        const dateRange2 = ref(getCurrentYearRange());

        const echarts = inject("echarts");
        let myChart = null;
        let resizeObserver = null;
        const isAdmin = ref(false);
        const userSite = ref('');
        const siteList = ref([]);

        // 获取最近30天（一个月）日期范围
        function getLast30DaysRange() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [formatDate(start), formatDate(end)];
        };

        // 获取 当年1月1日 ~ 今天
        function getCurrentYearRange() {
            const today = new Date();
            const firstDay = new Date(today.getFullYear(), 0, 1);
            return [formatDate(firstDay), formatDate(today)];
        }

        // 辅助函数：获取上个月的第一天和最后一天
        function getLastMonthRange() {
            const now = new Date();
            const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 0);
            return {
                start: formatDate(firstDayOfMonth),
                end: formatDate(lastDayOfMonth)
            };
        }

        // ==============================================
        // 表格1：收益趋势表（原 apiStatisticsAll2）
        // ==============================================
        const getProfitTrend1 = async () => {
            try {
                tableLoading1.value = true;
                const params = {
                    ...(dateRange1.value?.length === 2 ? {
                        startDate: dateRange1.value[0],
                        endDate: dateRange1.value[1]
                    } : {})
                };
                const res = await apiStatisticsAll2(params);
                let list = res.list || [];

                if (list.length > 0) {
                    const totalRow = { date: "合计", consumptionTotal:0, consumptionReturn:0, rechargeAmount:0, rechargeRefund:0, rechargeReturn:0 };
                    list.forEach(item => {
                        totalRow.consumptionTotal += Number(item.consumptionTotal||0);
                        totalRow.consumptionReturn += Number(item.consumptionReturn||0);
                        totalRow.rechargeAmount += Number(item.rechargeAmount||0);
                        totalRow.rechargeRefund += Number(item.rechargeRefund||0);
                        totalRow.rechargeReturn += Number(item.rechargeReturn||0);
                    });
                    list.push(totalRow);
                }
                tableData1.value = list;
            } catch (error) {
                ElMessage.error("获取收益趋势失败");
                console.error(error);
            } finally {
                tableLoading1.value = false;
            }
        }

        const resetDateRange1 = () => {
            dateRange1.value = getLast30DaysRange();
            getProfitTrend1();
        }

        // ==============================================
        // 表格2：实际收益表（apiCalculateActualConsumptionAndRecharge）
        // ==============================================
        const getProfitTrend2 = async () => {
            try {
                tableLoading2.value = true;
                const params = {
                    ...(dateRange2.value?.length === 2 ? {
                        startDate: dateRange2.value[0],
                        endDate: dateRange2.value[1],
                        groupBy: 'month'
                    } : {})
                };
                const res = await apiCalculateActualConsumptionAndRecharge(params);
                let list = res || [];

                if (list.length > 0) {
                    const totalRow = { date: "合计", actualConsumption:0, giftConsumption:0, actualRecharge:0, actualGiftRecharge:0, totalConsumption:0, packageDurationAmount:0, totalRecharge:0, totalRefund:0 };
                    list.forEach(item => {
                        totalRow.actualConsumption += Number(item.actualConsumption||0);
                        totalRow.giftConsumption += Number(item.giftConsumption||0);
                        totalRow.actualRecharge += Number(item.actualRecharge||0);
                        totalRow.actualGiftRecharge += Number(item.actualGiftRecharge||0);
                        totalRow.totalConsumption += Number(item.totalConsumption||0);
                        totalRow.packageDurationAmount += Number(item.packageDurationAmount||0);
                        totalRow.totalRecharge += Number(item.totalRecharge||0);
                        totalRow.totalRefund += Number(item.totalRefund||0);
                    });
                    list.push(totalRow);
                }
                tableData2.value = list;
            } catch (error) {
                ElMessage.error("获取实际收益失败");
                console.error(error);
            } finally {
                tableLoading2.value = false;
            }
        }

        const resetDateRange2 = () => {
            // 重置为：当年1月1日 ~ 今天
            dateRange2.value = getCurrentYearRange();
            getProfitTrend2();
        }

        // 日期格式化
        function formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

        // 获取站点列表
        const getSiteList = async () => {
            try {
                const res = await apiUserParkingLotList();
                siteList.value = res || [];
                data.searchOption[0].options = [
                    {label: "全部站点", value: ""},
                    ...siteList.value.map(item => ({label: item.name, value: item.id}))
                ];
            } catch (error) {
                ElMessage.error("获取站点列表失败");
                console.error(error);
            }
        };

        // 上个月日期范围
        const lastMonth = getLastMonthRange();

        // 搜索选项
        const data = reactive({
            detailedTitle: "",
            expenditureTableData: [],
            searchOption: [
                {
                    name: "站点",
                    type: "select",
                    key: "storeId",
                    value: "",
                    options: [],
                    paramsKey: {
                        site_id: "storeId",
                    },
                },
            ],
        });

        // 修复重置函数：匹配实际的searchOption结构
        const resetSearch = () => {
            data.searchOption[0].value = "";
            handleSearch();
        };

        // 安全获取DOM元素
        const getChartDom = () => {
            let chartDom = document.getElementById('main');
            let retryCount = 0;

            const retryGetDom = () => {
                retryCount++;
                chartDom = document.getElementById('main');
                if (!chartDom && retryCount < 5) {
                    setTimeout(retryGetDom, 200);
                }
            };

            if (!chartDom) {
                retryGetDom();
            }

            return chartDom;
        };

        // 渲染图表
        const renderChart = () => {
            if (!apiStatisticsMonthCountData.value || !echarts) return;

            if (myChart) {
                myChart.dispose();
                myChart = null;
            }

            setTimeout(async () => {
                const chartDom = getChartDom();
                if (!chartDom) {
                    ElMessage.warning("图表容器未加载，请展开收益趋势面板后重试");
                    return;
                }

                try {
                    myChart = echarts.init(chartDom);
                    const monthCountData = apiStatisticsMonthCountData.value || [];

                    const xAxisData = monthCountData.length
                        ? monthCountData.map(item => item.date || '')
                        : ['暂无数据'];
                    const countData = monthCountData.length
                        ? monthCountData.map(item => item.count || 0)
                        : [0];
                    const amountData = monthCountData.length
                        ? monthCountData.map(item => item.amount || 0)
                        : [0];

                    const isMobile = window.innerWidth < 768;

                    const option = {
                        legend: {data: ['使用次数', '收益金额'], top: 0},
                        tooltip: {
                            trigger: 'axis',
                            formatter: (params) => {
                                let res = params[0].name;
                                params.forEach(item => {
                                    const formattedValue = item.seriesName === '收益金额'
                                        ? Number(item.value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                        : item.value;
                                    res += `<br/>${item.seriesName}：${formattedValue}`;
                                });
                                return res;
                            }
                        },
                        ...(isMobile ? {} : {
                            toolbox: {
                                feature: {
                                    dataView: {show: true, readOnly: false},
                                    magicType: {show: true, type: ['line', 'bar']},
                                    restore: {show: true},
                                    saveAsImage: {show: true}
                                },
                                right: 10
                            },
                        }),
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: xAxisData,
                            axisLabel: {
                                rotate: 30
                            }
                        },
                        yAxis: [
                            {
                                type: 'value',
                                name: '使用次数',
                                position: 'left',
                                alignTicks: true,
                                axisLine: {
                                    show: true
                                }
                            },
                            {
                                type: 'value',
                                name: '收益金额（元）',
                                position: 'right',
                                axisLine: {
                                    show: true
                                }
                            }
                        ],
                        series: [
                            {
                                name: '使用次数',
                                type: 'bar',
                                yAxisIndex: 0,
                                data: countData,
                                markPoint: {
                                    data: [
                                        {type: 'max', name: '最大值'},
                                        {type: 'min', name: '最小值'}
                                    ]
                                },
                            },
                            {
                                name: '收益金额',
                                type: 'bar',
                                yAxisIndex: 1,
                                data: amountData,
                                markPoint: {
                                    data: [
                                        {type: 'max', name: '最大值'},
                                        {type: 'min', name: '最小值'}
                                    ]
                                },
                            }
                        ]
                    };

                    myChart.setOption(option);

                    window.addEventListener('resize', () => {
                        if (myChart) {
                            const newIsMobile = window.innerWidth < 768;
                            myChart.setOption({
                                ...(newIsMobile ? {} : {
                                    toolbox: {
                                        feature: {
                                            dataView: {show: true, readOnly: false},
                                            magicType: {show: true, type: ['line', 'bar']},
                                            restore: {show: true},
                                            saveAsImage: {show: true}
                                        },
                                        right: 10
                                    },
                                })
                            });
                            myChart.resize();
                        }
                    });

                } catch (error) {
                    console.error("渲染图表失败：", error);
                    ElMessage.error("图表渲染失败，请刷新页面重试");
                }
            }, 500);
        };

        // 处理折叠面板切换
        const handleCollapseChange = (val) => {
            if (val.includes('3')) {
                nextTick(() => {
                    setTimeout(() => {
                        renderChart();
                    }, 300);
                });
            }
            if (val.includes('4')) {
                getProfitTrend1();
            }
            if (val.includes('5')) {
                getProfitTrend2();
            }
        };

        // 查询逻辑
        const handleSearch = async (eve='',stationId = '') => {
            try {
                loading.value = true;
                const searchParams = stationId ? {storeId: stationId} : mainTempRef.value?.searchParams;
                const [
                    statisticsAllRes,
                    dayCountRes,
                    monthCountRes
                ] = await Promise.all([
                    apiStatisticsAll(searchParams),
                    apiStatisticsDayCount(searchParams),
                    apiStatisticsMonthCount(searchParams),
                ]);

                statisticsAllData.value = statisticsAllRes;
                apiStatisticsDayCountData.value = dayCountRes;
                apiStatisticsMonthCountData.value = monthCountRes;

                renderChart();

            } catch (error) {
                ElMessage.error("数据加载失败，请重试");
                console.error("查询失败：", error);
            } finally {
                loading.value = false;
            }
        };

        const getNowUserList = async () => {
            try {
                const res = await apiUserParkingLot();
                userSite.value = res.name;
                await handleSearch(0,res.id)
            } catch (error) {
                console.error("获取当前用户列表失败：", error);
            }
        };

        // 查看详情
        const handleLookDetails = (type) => {
            const titleConfig = {
                0: "门店1",
                4: "门店2",
                2: "门店3",
                1: "门店4",
            };
            data.detailedTitle = titleConfig[type];
            detailedRef.value.handleSetSource(type);
            detailedRef.value.hanleToggle(true);
        };

        provide("handleSearch", handleSearch);

        onMounted(async () => {
            const getUserName = localStorage.getItem("userInfo")
            const userId = JSON.parse(getUserName).userId;
            isAdmin.value = userId === 22;

            await nextTick();
            await getSiteList();
            await handleSearch();

            if (!isAdmin.value){
                await getNowUserList()
            }

            renderChart();
            // 初始化两个表格
            getProfitTrend1();
            getProfitTrend2();
        });

        // 清理资源
        onBeforeUnmount(() => {
            if (myChart) {
                myChart.dispose();
                myChart = null;
            }
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        });

        return {
            statisticsAllData,
            handleCollapseChange,
            activeNames,
            handleLookDetails,
            detailedRef,
            mainTempRef,
            data,
            handleSearch,
            resetSearch,
            isAdmin,
            userSite,
            loading,
            siteList,
            formatDate,
            lastMonth,
            getLastMonthRange,

            // 表格1
            dateRange1,
            tableLoading1,
            tableData1,
            getProfitTrend1,
            resetDateRange1,

            // 表格2
            dateRange2,
            tableLoading2,
            tableData2,
            getProfitTrend2,
            resetDateRange2,
        };
    },
};
</script>

<style scoped>
/* 新增：确保图表容器始终存在（即使折叠） */
.chart-wrapper {
    width: 100%;
    height: 400px;
}
.chart-hidden {
    visibility: hidden;
    height: 0;
    overflow: hidden;
}

/* 原有样式 */
.fm-header__gap { padding-left: 10px; }
.fm-collapse { padding: 0; margin-top: 10px; }
.fm-board {
    width: 100%;
    background: #fff;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}
.fm-card {
    flex: 1;
    min-width: 200px;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.3s ease;
    position: relative;
    box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.1);
}
.fm-card:hover {
    transform: translateY(-5px);
    box-shadow: inset 0 0 15px rgba(255, 255, 255, 0.2), 0 5px 15px rgba(0, 0, 0, 0.1);
}
.fm-card__body {
    flex: 1;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
}
.fm-card__icon {
    width: 56px;
    height: 56px;
    transition: all 0.3s ease;
    color: #fff;
    opacity: 0.9;
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.2));
    display: flex;
    align-items: center;
    justify-content: center;
}
.fm-card:hover .fm-card__icon {
    transform: scale(1.1);
    opacity: 1;
    filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));
}
.fm-card__text {
    color: #fff;
    text-align: right;
    position: relative;
    z-index: 1;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.fm-card__count {
    font-size: 28px;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 8px;
}
.fm-card__desc {
    font-size: 14px;
    opacity: 0.9;
}
.fm-card--online  {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.fm-card--vip      {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}
.fm-card--balance  {
    background: linear-gradient(135deg, #4158d0 0%, #c850c0 100%);
}
.fm-card--today-use {
    background: linear-gradient(135deg, #0093e9 0%, #80d0c7 100%);
}
.fm-card--today-earn {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}
.fm-chart {
    width: 100%;
    height: 400px;
    background: #fff;
}
::v-deep .el-collapse {
    border: none;
}
::v-deep .el-collapse-item {
    border: none;
    margin-bottom: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    overflow: hidden;
}
::v-deep .el-collapse-item__header {
    padding: 16px 20px;
    border-radius: 0;
    background: #f8f9fa;
    font-weight: 500;
    font-size: 16px;
}
::v-deep .el-collapse-item__content {
    padding: 20px;
    background: #fff;
    display: block !important;
    height: auto !important;
}
::v-deep .fm-search {
    padding: 15px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    margin-bottom: 15px;
}
::v-deep .el-skeleton {
    border-radius: 8px;
}

/* 移动端适配 */
@media screen and (max-width: 767px) {
    .fm-card {
        min-width: 100%;
        height: 120px;
    }
    .fm-card__body {
        padding: 15px;
    }
    .fm-card__icon {
        width: 40px;
        height: 40px;
    }
    .fm-card__count {
        font-size: 20px;
    }
    .fm-card__desc {
        font-size: 12px;
    }
    .chart-wrapper, .fm-chart {
        height: 300px;
    }
    .search-bar {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .search-bar .el-date-picker {
        width: 100% !important;
        margin-right: 0 !important;
    }
}
.userSite {
    border-radius: 8px;
    padding: 20px 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}
/* 合计行样式 */
::v-deep .el-table__body tr:last-child td {
    background-color: #fafafa !important;
    font-weight: 600;
    color: #333;
}
</style>
